import React from 'react';
import { ToggleField } from '@bucketplace/commerce-admin-ui';

import { ColorPickerField, DurationInputField, FormContent, InspectorFormProvider, LogDataFormGroup } from '@/components';
import { useBlockContext } from '@/contexts';
import { DocumentInspectorProps, DocumentNode } from '@/types';
import { convertDurationFormat } from '@/utils';

import { BlockProps } from '../Block';
import { BoxModelForm } from './BoxModelForm';

export function BlockInspector({
  value,
  onChange,
}: DocumentInspectorProps<BlockProps>) {
  const convertedDuration = convertDurationFormat(value.props.duration);
  const formValue = {
    ...value,
    props: {
      ...value.props,
      duration: convertedDuration,
    },
  };

  return (
    <InspectorFormProvider value={formValue} onChange={onChange}>
      <BlockInspectorFields value={formValue} />
    </InspectorFormProvider>
  );
}

export function BlockInspectorFields({
  value,
}: {
  value: DocumentNode<BlockProps>,
}) {
  const { setImpressionLogData } = useBlockContext();

  const { children, ...others } = value ?? {};

  return (
    <>
      <BoxModelForm />
      <FormContent header="배경색">
        <ColorPickerField name="background" width="100%" />
      </FormContent>
      <FormContent header="노출시간 설정">
        <ToggleField name="duration" />
      </FormContent>
      { !!value.props.duration && (
        <FormContent header="노출시간" direction="VERTICAL">
          <DurationInputField name="duration" />
        </FormContent>
      ) }
      <LogDataFormGroup
        nodeKey={value?.key}
        label="Impression 로그"
        {...setImpressionLogData?.(others)}
      />
    </>
  );
}
